/**
 * Makeup tab — extracted from ClientDetail.jsx (Feb 2026).
 *
 * Receives all the parent state it needs as props rather than touching
 * any module-level singleton. Dimension dropped from inline 37 lines
 * to a focused, testable component without changing behaviour.
 *
 * Contract:
 *   • client       — current client document (read).
 *   • setClient    — setter for the parent's client state (used after
 *                    trial photo uploads so the parent re-renders).
 *   • team         — list of team members (for ArtistPicker).
 *   • id           — client id (passed verbatim to TrialBlock).
 *   • patch(field, value) — mutates a single client field; the parent
 *                    handles persistence.
 */
import React from "react";
import ArtistPicker from "@/components/ArtistPicker";
import AssistantsPicker from "@/components/AssistantsPicker";
import MakeupSheet from "@/pages/MakeupSheet";
import TrialBlock from "@/pages/TrialBlock";

export default function MakeupTab({ client, setClient, team, id, patch }) {
  return (
    <div className="space-y-6">
      <div className="flex items-baseline gap-3 flex-wrap">
        <h2 className="font-serif-heading text-3xl">Scheda trucco</h2>
        <p className="text-sm text-neutral-500">Tutti i prodotti e le decisioni del look — pronta per il giorno dell'evento.</p>
      </div>

      <ArtistPicker
        kind="makeup"
        team={team}
        value={client.makeup_artist_id || ""}
        onChange={(v) => patch("makeup_artist_id", v)}
        testid="makeup-artist-picker"
      />

      <AssistantsPicker
        team={team}
        value={client.assistant_ids || []}
        onChange={(v) => patch("assistant_ids", v)}
        testid="makeup-assistants-picker"
      />

      <MakeupSheet client={client} onPatch={patch} />

      <div className="bg-white border border-border rounded-sm p-6">
        <TrialBlock
          kind="makeup"
          client={client}
          clientId={id}
          onChange={(c) => setClient(c)}
          onSavedTrial={(k, t) => setClient((c) => ({ ...c, [k]: { ...(c[k] || {}), trial: t } }))}
        />
      </div>
    </div>
  );
}
